import * as types from '../actions/ActionTypes';

const initialState = {
  loading: false,
  tasksList: [],
  tasksDropdownList: [],
  taskRecord: null,
  redirectToList: false,
  validation_error: "",
  showUpdateForm: false,
  showViewPage: false,
  formState: {}
};

const TimesheetTaskReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.TASKS_REQUEST:
      return { ...state, loading: true, redirectToList: false, validation_error: "" };
    case types.TASKS_SUCCESS:
      return { ...state, loading: false, tasksList: action.tasksList };
    case types.TASKS_DROPDOWN_SUCCESS:
      return { ...state, loading: false, tasksDropdownList: action.tasksDropdownList };
    case types.TASKS_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        taskRecord: action.record,
        formState: action.record, // Initialize formState with record data
        showUpdateForm: action.actionType === 'update',
        showViewPage: action.actionType === 'view',
      };
    case types.TASKS_VALIDATION_ERROR: 
      return { ...state, loading: false, validation_error: action.validation_error };
    case types.TASKS_REDIRECT:
      return {
        ...state,
        redirectToList: true,
        showUpdateForm: false,
        showViewPage: false,
        taskRecord: null,
        formState: {},
        validation_error: ""
      };
    case types.HIDE_TASKS_FEILD_VALIDATION_ERROR:
      if (state.validation_error && state.validation_error[action.feild_key]) {
          const new_validation_error = { ...state.validation_error };
          delete new_validation_error[action.feild_key];
          return { ...state, validation_error: new_validation_error };
      }
      return state;
    default:
      return state;
  }
};

export default TimesheetTaskReducer;
